import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { memberPlans } from "@/mocks/home";

export default function Membership() {
  return (
    <section id="membership" className="scroll-mt-section bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="会员体系"
            title="三种档位，按习惯选择"
            subtitle="从免费用户到标准会员再到 VIP，档位越高，可选的清晰度、离线额度与体验越完整。可以先从日常需求出发判断是否需要升级。"
            align="center"
          />
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 items-stretch">
          {memberPlans.map((plan, index) => (
            <Reveal key={plan.name} delay={index * 100} className="h-full">
              <article
                className={`relative h-full flex flex-col rounded-lg border p-6 ${
                  plan.highlight
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-100 border-background-200"
                }`}
              >
                <span
                  className={`absolute top-6 right-6 rounded-full px-3 py-1 text-xs font-label ${
                    plan.highlight
                      ? "bg-background-50/20 text-background-50"
                      : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  {plan.badge}
                </span>

                <span
                  className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl ${
                    plan.highlight
                      ? "bg-background-50/20 text-background-50"
                      : "bg-accent-100 text-accent-700"
                  }`}
                >
                  <i className={plan.icon} />
                </span>

                <h3
                  className={`mt-4 font-heading text-xl font-bold ${
                    plan.highlight ? "text-background-50" : "text-foreground-950"
                  }`}
                >
                  {plan.name}
                </h3>
                <p
                  className={`mt-2 text-sm leading-relaxed ${
                    plan.highlight ? "text-background-100" : "text-foreground-600"
                  }`}
                >
                  {plan.desc}
                </p>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {plan.features.map((feature) => (
                    <li
                      key={feature}
                      className={`flex gap-2.5 text-sm leading-relaxed ${
                        plan.highlight ? "text-background-50" : "text-foreground-700"
                      }`}
                    >
                      <i
                        className={`ri-check-line text-lg shrink-0 ${
                          plan.highlight ? "text-background-50" : "text-primary-500"
                        }`}
                      />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-6 text-center text-xs md:text-sm text-foreground-500 leading-relaxed">
            以上为各档位的功能差异说明，具体可用的清晰度与额度以实际客户端内展示为准。
          </p>
        </Reveal>
      </div>
    </section>
  );
}